import { useMemo } from "react";
import { t } from "ttag";

import { useListPopularItemsQuery } from "metabase/api";
import { LoadingAndErrorWrapper } from "metabase/common/components/LoadingAndErrorWrapper";
import { useGetIcon } from "metabase/hooks/use-icon";
import * as Urls from "metabase/urls";
import { getName } from "metabase/utils/name";

import { dashboardsOnly } from "../../utils";
import { HomeCaption } from "../HomeCaption";
import { HomeHelpCard } from "../HomeHelpCard";
import { HomeModelCard } from "../HomeModelCard";

import S from "./HomePopularSection.module.css";

export const HomePopularSection = (): JSX.Element => {
  const getIcon = useGetIcon();
  const {
    data: popularItemsRaw = [],
    isLoading,
    error,
  } = useListPopularItemsQuery(undefined, { refetchOnMountOrArgChange: true });

  const popularItems = useMemo(
    () => dashboardsOnly(popularItemsRaw),
    [popularItemsRaw],
  );

  if (isLoading || error) {
    return <LoadingAndErrorWrapper loading={isLoading} error={error} />;
  }

  return (
    <div>
      <HomeCaption>{t`Here are some popular dashboards`}</HomeCaption>
      <div className={S.SectionBody}>
        {popularItems.map((item, index) => (
          <HomeModelCard
            key={index}
            title={getName(item)}
            icon={getIcon(item)}
            url={Urls.modelToUrl(item) ?? ""}
          />
        ))}
        <HomeHelpCard />
      </div>
    </div>
  );
};
